import type { TFeatureFlags } from "@citrine/configuration";

export const RUNTIME_CONFIG_KEY = ["runtime-config"];

export interface IConfiguration extends TFeatureFlags {
  deploymentEnv: string;
}
